module.exports = __webpack_public_path__ + "static/media/CloseModal.b30ffbb1.svg";